import { signalStore, withMethods, withState } from '@ngrx/signals';

interface InfoscreenDummyDataState {
  lockerRoomNames: readonly string[];
  danishCityTeams: readonly string[];
  sportActivities: readonly string[];
  skillLevels: readonly string[];
}

const initialState: InfoscreenDummyDataState = {
  lockerRoomNames: [
    'Omklædning H01',
    'Omklædning H02',
    'Omklædning H03',
    'Omklædning B12',
    'Omklædning B14',
    'Omklædning B16',
    'Omklædning Nord A',
    'Omklædning Syd C',
    'Omklædning Vest D',
    'Omklædning Øst E',
    'Omklædning Hal 1',
    'Omklædning Hal 2',
  ],
  danishCityTeams: [
    'København',
    'Aarhus',
    'Odense',
    'Aalborg',
    'Esbjerg',
    'Randers',
    'Kolding',
    'Horsens',
    'Vejle',
    'Roskilde',
  ],
  sportActivities: [
    'Fodbold',
    'Håndbold',
    'Badminton',
    'Volleyball',
    'Basketball',
    'Tennis',
    'Svømning',
    'Gymnastik',
    'Aerobic',
    'Yoga',
    'Pilates',
    'Spinning',
    'Crossfit',
    'Bordtennis',
    'Squash',
    'Dans',
    'Kampsport',
    'Løb',
    'Styrketræning',
    'Zumba',
  ],
  skillLevels: [
    '1. Senior',
    '2. Senior',
    '3. Senior',
    'U21 - Herre',
    'U21 - Dame',
    'U19 - Herre',
    'U19 - Dame',
    'U17 - Herre',
    'U17 - Dame',
    'U15 - Herre',
    'U15 - Dame',
    'Miniputter',
    'Begynder',
    'Øvet',
    'Elite',
    'Motionist',
    'Veteran',
  ],
};

export const InfoscreenDummyDataStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    getRandomLockerRoomName(): string {
      const names = store.lockerRoomNames();
      return names[Math.floor(Math.random() * names.length)];
    },
    getRandomDanishCityTeam(): string {
      const cities = store.danishCityTeams();
      const city = cities[Math.floor(Math.random() * cities.length)];
      const suffix = Math.random() > 0.5 ? 'Klub' : 'IF';
      return `${city} ${suffix}`;
    },
    getRandomSportActivity(): string {
      const activities = store.sportActivities();
      return activities[Math.floor(Math.random() * activities.length)];
    },
    getRandomSkillLevel(): string {
      const levels = store.skillLevels();
      return levels[Math.floor(Math.random() * levels.length)];
    },
  }))
);
